export default {
  title: {
    id: 'product_jp_reassurance_insurance_return_title',
    defaultMessage: 'Free 30-days returns',
  },
  subtitle: {
    id: 'product_jp_reassurance_insurance_return_subtitle',
    defaultMessage: "\\ Even after you've used it! /",
  },
  disclaimer: {
    id: 'product_jp_reassurance_insurance_return_disclaimer',
    defaultMessage:
      'Except in cases of damage caused by the customer, you can return the product within 30 days of delivery for a full refund or exchange',
  },
  step1TagLabel: {
    id: 'product_jp_reassurance_insurance_return_step1_tag_label',
    defaultMessage: 'Step 1.',
  },
  step1Title: {
    id: 'product_jp_reassurance_insurance_return_step1_title',
    defaultMessage: 'Contact customer support',
  },
  step1Subtitle: {
    id: 'product_jp_reassurance_insurance_return_step1_subtitle',
    defaultMessage:
      "Log in to your account and contact us through your 'Order History'.",
  },
  step2TagLabel: {
    id: 'product_jp_reassurance_insurance_return_step2_tag_label',
    defaultMessage: 'Step 2.',
  },
  step2Title: {
    id: 'product_jp_reassurance_insurance_return_step2_title',
    defaultMessage: 'Prepare for returns',
  },
  step2Subtitle: {
    id: 'product_jp_reassurance_insurance_return_step2_subtitle',
    defaultMessage: 'Follow a few simple steps to return your item correctly.',
  },
  step3TagLabel: {
    id: 'product_jp_reassurance_insurance_return_step3_tag_label',
    defaultMessage: 'Step 3.',
  },
  step3Title: {
    id: 'product_jp_reassurance_insurance_return_step3_title',
    defaultMessage: 'Send back to the seller',
  },
  step3Subtitle: {
    id: 'product_jp_reassurance_insurance_return_step3_subtitle',
    defaultMessage: 'You can choose between home pickup or drop-off.',
  },
  step4TagLabel: {
    id: 'product_jp_reassurance_insurance_return_step4_tag_label',
    defaultMessage: 'Step 4.',
  },
  step4Title: {
    id: 'product_jp_reassurance_insurance_return_step4_title',
    defaultMessage: 'Get refund',
  },
  step4Subtitle: {
    id: 'product_jp_reassurance_insurance_return_step4_subtitle',
    defaultMessage: "We'll transfer the refund to the payment you used.",
  },
}
